import { Button, Flex, message, Typography } from "antd";
import React, { useEffect } from "react";
import { useUserFilesTabs } from "./UserFilesTabsContext";
import ReactQuill from "react-quill";
import Quill from "quill";
import "react-quill/dist/quill.snow.css";
import useSWRMutation from "swr/mutation";
import { patchPostFetcher } from "../../../utils/fetcher";
import moment from "moment";
import { mutate } from "swr";
import { AppModal } from "../../../components/common";

type TherapyGoalsPayload = {
  actionType: "therapy_goals";
  title: string;
  description: string;
};

export default function GoalsInTheraphyModal() {
  const {
    goalsInTheraphyModal,
    setGoalsInTheraphyModal,
    selectedModalObjGoals,
  } = useUserFilesTabs();

  const [formData, setFormData] = React.useState<
    Omit<TherapyGoalsPayload, "actionType">
  >({
    title: selectedModalObjGoals?.formData?.title,
    description: selectedModalObjGoals?.formData?.description,
  });
  console.log(selectedModalObjGoals, "selectedModalObjGoals");

  const API_URL = process.env.REACT_APP_API_URL;
  const { Paragraph } = Typography;
  const quillModules = React.useMemo(
    () => ({
      toolbar: {
        container: [
          ["undo", "redo"],
          [{ header: [false, 1, 2, 3] }],
          [{ align: [] }],
          [{ color: [] }],
          ["bold", "italic", "underline", "strike"],
          ["code-block"],
          [{ list: "bullet" }, { list: "ordered" }],
          ["link", "image"],
          ["blockquote"],
          ["clean"],
        ],
        handlers: {
          undo: function (this: any) {
            this.quill.history.undo();
          },
          redo: function (this: any) {
            this.quill.history.redo();
          },
        },
      },
    }),
    [],
  );

  useEffect(() => {
    setFormData({
      title: selectedModalObjGoals?.formData?.title,
      description: selectedModalObjGoals?.formData?.description,
    });
  }, [selectedModalObjGoals]);

  const isFormFilled =
    !!selectedModalObjGoals?.formData &&
    Object.values(selectedModalObjGoals?.formData).some(
      (v) => v !== "" && v !== false && v != null,
    );

  const { trigger: sessionReportTrigger, isMutating: sessionReportLoading } =
    useSWRMutation<unknown, unknown, string, TherapyGoalsPayload>(
      isFormFilled
        ? `${API_URL}/sessionAction/action/${selectedModalObjGoals?.actionId}`
        : `${API_URL}/sessionAction/session/${selectedModalObjGoals?.sessionId}`,
      (url, { arg }) =>
        patchPostFetcher({
          url,
          data: arg,
          method: isFormFilled ? "PUT" : "POST",
        }),
    );

  React.useEffect(() => {
    const icons = Quill.import("ui/icons");
    icons.undo = `<svg width="16" height="16" viewBox="0 0 24 24"><path d="M12 5v-3l-5 5 5 5v-3c3.3 0 6 2.7 6 6 0 1-.2 2-.7 2.9l1.5 1.5c.8-1.2 1.2-2.7 1.2-4.4 0-4.4-3.6-8-8-8z"/></svg>`;
    icons.redo = `<svg width="16" height="16" viewBox="0 0 24 24"><path d="M12 5v-3l5 5-5 5v-3c-3.3 0-6 2.7-6 6 0 1 .2 2 .7 2.9l-1.5 1.5C4.4 18.2 4 16.7 4 15c0-4.4 3.6-8 8-8z"/></svg>`;
  }, []);

  const handleSave = async () => {
    const payload: TherapyGoalsPayload = {
      actionType: "therapy_goals",
      title: "Goals in Therapy",
      description: formData.description,
    };

    try {
      await sessionReportTrigger(payload);
      message.success(
        isFormFilled ? "Successfully updated" : "Successfully created",
      );

      mutate(
        `${API_URL}/session/sessionAction/byUserId/${selectedModalObjGoals?.clientId}/therapy_goals`,
      );
      setGoalsInTheraphyModal(false);
    } catch (err) {
      console.error("Failed to save therapy goals", err);
    }
  };
  // console.log(formData,"udhaya");

  const title = () => (
    <Flex justify="space-between" align="center">
      <Typography className="font18">Goals in therapy</Typography>
      <Flex className="titleBtns" gap={8} justify="center" align="center">
        <Paragraph className="lastEdited">
          Last edited{" "}
          {moment(selectedModalObjGoals?.updatedAt).format("DD/MM/YY hh:mm A")}
        </Paragraph>
        <Button
          type="default"
          className="saveBtn"
          loading={sessionReportLoading}
          onClick={handleSave}
        >
          Save
        </Button>
        <Button
          type="primary"
          className="discardBtn"
          onClick={() => setGoalsInTheraphyModal(false)}
        >
          Discard
        </Button>
      </Flex>
    </Flex>
  );

  return (
    <AppModal
      className="goalsInTheraphyModal"
      title={title()}
      open={goalsInTheraphyModal}
      onCancel={() => setGoalsInTheraphyModal(false)}
    >
      
        <ReactQuill
          theme="snow"
          modules={quillModules}
         
          value={formData.description}
          onChange={(value) =>
            setFormData((prev) => ({
              ...prev,
              description: value,
            }))
          }
        />
      
    </AppModal>
  );
}
